<template>
  <v-menu
      v-model="showInfoProgress"
      offset-y
      open-on-hover
      nudge-bottom="15px"
      nudge-left="225px"
      rounded="xl"
      style="max-width: 300px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          icon
          class="rounded-xl"
          v-bind="attrs"
          v-on="on"
      >
        <v-icon size="21">
          fa fa-info-circle
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar size="8" color="teal darken-3"></v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Ставка: {{bidBasicProgress}}%</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar size="8" :color="isHeadDepartment ? '#f2711c' : 'error'"></v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Зав.кафедрой: {{isHeadDepartment ? `${headDepartmentBasicProgress}%` : 'Недоступен'}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar size="8" :color="isDean ? 'blue darken-1' : 'error'"></v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Декан: {{isDean ? `${deanBasicProgress}%` : 'Недоступен'}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "TheDecipheringProgressContract",

  data() {
    return {
      showInfoProgress: false,
    }
  },

  props: {
    bidBasicProgress: Number,
    headDepartmentBasicProgress: Number,
    deanBasicProgress: Number,
  },

  computed: {
    ...mapGetters({
      isDean: "effective_contract/isDean",
      isHeadDepartment: "effective_contract/isHeadDepartment",
    }),
  },

}
</script>

<style scoped>

</style>